import { getPosition } from '@components/ArtBoard/Node/components/NodeTags/helper'
import css from '@components/ArtBoard/Node/components/NodeTags/NodeTags.module.scss'
import type { TagItem } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import { useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { TAGS_PERMISSION } from '@/permissions/project/definitions'
import lightOrDark from '@/utils/color/lightOrDark'

export const MultipleTagItem = ({
  tags,
  tag,
  index,
}: {
  tags: TagItem[]
  tag: TagItem
  index: number
}) => {
  const colorHex = useSelector(
    migrationProjectSelector.getProjectColorHexOrDefault(tag.colorId)
  )

  const getMultipleTagStyle = (index: number) => ({
    left: getPosition(tags.length, index),
  })

  const { hasAccess } = useProjectAccess(TAGS_PERMISSION.SHOW)

  return (
    <div
      key={tag.id}
      className={cx(css.multipleTag, {
        [css.moreThanTen]: tags.length > 10,
      })}
      style={getMultipleTagStyle(index)}
    >
      <div
        className={cx(css.tagBadge, css.multiple, {
          [css.darkColor]: lightOrDark(colorHex) === 'light',
        })}
        style={{ backgroundColor: colorHex }}
      >
        <span className={css.text}>{tag.title}</span>
      </div>
      <button
        style={{ backgroundColor: colorHex }}
        className={cx(css.tagSpot, {
          [css.cursorDefault]: !hasAccess,
        })}
        type="button"
      />
    </div>
  )
}
